<script setup>
import { computed } from 'vue';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from 'dashboard/components/ui/table';

const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
  widgetStyle: {
    type: Object,
    default: () => ({}),
  },
});

const title = computed(() => props.widget.title);
const headers = computed(() => props.widget.properties?.headers || []);
const rows = computed(() => props.widget.properties?.rows || []);
</script>

<template>
  <div
    class="h-full flex flex-col group font-inter p-5 bg-white rounded-[20px] shadow-xl border border-slate-100"
  >
    <div v-if="title" class="mb-4 flex items-center justify-between px-1">
      <div class="flex items-center gap-3">
        <div
          class="flex h-8 w-8 items-center justify-center rounded-full bg-slate-50 text-slate-500 group-hover:text-indigo-500 group-hover:bg-indigo-50 transition-all duration-200"
        >
          <span class="i-lucide-table h-4 w-4" />
        </div>
        <h3 class="text-base font-bold text-slate-900 tracking-tight">
          {{ title }}
        </h3>
      </div>
    </div>
    <div
      class="flex-1 -mx-5 -mb-5 overflow-hidden rounded-b-[20px] border-t border-slate-100"
    >
      <div class="relative w-full overflow-auto custom-scrollbar">
        <Table class="w-full border-collapse">
          <TableHeader>
            <TableRow
              class="hover:bg-transparent border-b border-slate-100 bg-slate-50/50"
            >
              <TableHead
                v-for="(header, index) in headers"
                :key="index"
                class="h-10 text-[10px] font-bold uppercase tracking-widest first:pl-5 last:pr-5 text-slate-400 whitespace-nowrap"
              >
                {{ header }}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow v-if="rows.length === 0" class="hover:bg-transparent">
              <TableCell :colspan="headers.length" class="h-48 text-center">
                <span class="text-[13px] font-medium text-slate-400"
                  >No data found</span
                >
              </TableCell>
            </TableRow>
            <TableRow
              v-for="(row, rowIndex) in rows"
              :key="rowIndex"
              class="border-b border-slate-50 last:border-none transition-all duration-200 hover:bg-slate-50/30"
            >
              <TableCell
                v-for="(cell, cellIndex) in row"
                :key="cellIndex"
                class="py-3.5 text-[13px] font-medium first:pl-5 last:pr-5 text-slate-600 whitespace-nowrap"
              >
                {{ cell }}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  </div>
</template>
